<template>
  <img
    class="lazyload"
    :class="custom_class"
    data-sizes="auto"
    data-widths="[180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024]"
    :data-src="src"
  />
</template>

<script>
export default {
  props: ["src", "custom_class"]
};
</script>
